import { toCredentialJson } from '@modules/passkey/helpers/credential-json.helper';

export const createCredentialJson = async (options: PublicKeyCredentialCreationOptions): Promise<string | null> => {
  const credential = await navigator.credentials.create({ publicKey: options });
  if (!credential) {
    return null;
  }

  return toCredentialJson(credential as PublicKeyCredential);
};

export const getCredentialJson = async (options: PublicKeyCredentialRequestOptions): Promise<string | null> => {
  const credential = await navigator.credentials.get({ publicKey: options });
  if (!credential) {
    return null;
  }

  return toCredentialJson(credential as PublicKeyCredential);
};
